export default __webpack_public_path__ + "static/media/logo.0cc7d651.png";